/**
 * External dependencies
 */
import React from "react";

interface Term {
	id: number;
	name: string;
	link: string;
}

interface ServiceCardProps {
	id: number;
	title: string;
	link?: string;
	excerpt: string;
	icon: {
		url?: string;
		height: number;
		width: number;
	};
	className?: string;
}

const ServiceCard = ({
	id,
	title,
	excerpt,
	link,
	icon,
	className = "",
}: ServiceCardProps) => {
	const componentClass = [
		"em-block-service-card",
		"animated",
		"duration--fast",
		"wrapper-link",
		"fadeIn",
		className,
	];

	// Get the translation string for Read more button
	// @ts-ignore
	const config = window.emYtkBlocksConfig;

	// Define the fallback "Read more" translation string for the editor view
	let fallbackReadMore = "Lue lisää"
	if (document.body.classList.contains("pll-lang-en")) {
		fallbackReadMore = "Read more"
	} else if (document.body.classList.contains("pll-lang-sv")) {
		fallbackReadMore = "Läs mer"
	}

	return (
		<article className={componentClass.join(" ")}>
			<a href={link} className="em-block-service-card__link">
				{icon && 
					<img className="em-block-service-card__icon" alt="" src={icon.url} />
				}
				<h3 className="em-block-service-card__title" dangerouslySetInnerHTML={{ __html: title }} />
				<p className="em-block-service-card__description" dangerouslySetInnerHTML={{ __html: excerpt }} />
				<div className="wp-block-button is-style-text em-block-service-card__read-more">
					<span className="wp-block-button__link wp-element-button" aria-hidden="true">{config?.text?.readMore ?? fallbackReadMore}</span>
				</div>
			</a>
		</article>
	);
};

export default ServiceCard;
